import { Store } from 'vuex'
import moment from 'moment'
import { emitter } from '@kwixeo/interface-vue'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.SaleTermCreated',
    callback: (data: {id: number; updated_at: string; }): void => {
      const term = store.state.sales.contractModels.find((term: KwixeoSales.SaleTerm) => term.id === data.id)
      if (!term || moment(term.updated_at).isBefore(data.updated_at)) {
        store.dispatch('sales/loadSaleTerm', data.id)
      }
    }
  },
  {
    name: '.SaleTermUpdated',
    callback: (data: {id: number; updated_at: string; }): void => {
      const term = store.state.sales.contractModels.find((term: KwixeoSales.SaleTerm) => term.id === data.id)
      if (!term || moment(term.updated_at).isBefore(data.updated_at)) {
        store.dispatch('sales/loadSaleTerm', data.id)
      }
    }
  },
  {
    name: '.SaleTermDeleted',
    callback: (term: KwixeoSales.SaleTerm): void => {
      store.dispatch('sales/deleteSaleTerm', term)
    }
  },

  {
    name: '.PdfModelCreated',
    callback: (model: KwixeoSales.PdfModel): void => {
      store.dispatch('sales/setPdfModel', model)
    }
  },
  {
    name: '.PdfModelUpdated',
    callback: (model: KwixeoSales.PdfModel): void => {
      store.dispatch('sales/setPdfModel', model)
    }
  },
  {
    name: '.PdfModelDeleted',
    callback: (model: KwixeoSales.PdfModel): void => {
      store.dispatch('sales/deletePdfModel', model)
    }
  },

  {
    name: '.AccountCreated',
    callback: (account: KwixeoSales.Account): void => {
      store.dispatch('sales/setAccount', account)
    }
  },
  {
    name: '.AccountUpdated',
    callback: (account: KwixeoSales.Account): void => {
      store.dispatch('sales/setAccount', account)
    }
  },
  {
    name: '.AccountDeleted',
    callback: (account: KwixeoSales.Account): void => {
      store.dispatch('sales/deleteAccount', account)
    }
  },

  {
    name: '.BankCreated',
    callback: (bank: KwixeoSales.SyncBank): void => {
      emitter.emit('bankCreated', bank)
    }
  },
  {
    name: '.BankUpdated',
    callback: (bank: KwixeoSales.SyncBank): void => {
      emitter.emit('bankUpdated', bank)
    }
  },
  {
    name: '.BankDeleted',
    callback: (bank: KwixeoSales.SyncBank): void => {
      emitter.emit('bankDeleted', bank)
    }
  },

  {
    name: '.GrantCreated',
    callback: (grant: KwixeoSales.Grant): void => {
      store.dispatch('sales/setGrant', grant)
    }
  },
  {
    name: '.GrantUpdated',
    callback: (grant: KwixeoSales.Grant): void => {
      store.dispatch('sales/setGrant', grant)
    }
  },
  {
    name: '.GrantDeleted',
    callback: (grant: KwixeoSales.Grant): void => {
      store.dispatch('sales/deleteGrant', grant)
    }
  },

  {
    name: '.RecoveryInvoiceStepCreated',
    callback: (step: KwixeoSales.InvoiceRecoveryStep): void => {
      store.dispatch('sales/setRecoveryStep', step)
    }
  },
  {
    name: '.RecoveryInvoiceStepUpdated',
    callback: (step: KwixeoSales.InvoiceRecoveryStep): void => {
      store.dispatch('sales/setRecoveryStep', step)
    }
  },
  {
    name: '.RecoveryInvoiceStepDeleted',
    callback: (step: KwixeoSales.InvoiceRecoveryStep): void => {
      store.dispatch('sales/deleteRecoveryStep', step)
    }
  },

  {
    name: '.ContractModelCreated',
    callback: (data: {id: number; updated_at: string; }): void => {
      store.dispatch('sales/loadContractModel', data.id)
    }
  },
  {
    name: '.ContractModelUpdated',
    callback: (data: {id: number; updated_at: string; }): void => {
      const model = store.state.sales.contractModels.find((contract: KwixeoSales.ContractModel) => contract.id === data.id)
      if (!model || moment(model.updated_at).isBefore(data.updated_at)) {
        store.dispatch('sales/loadContractModel', data.id)
      }
    }
  },
  {
    name: '.ContractModelDeleted',
    callback: (data: {id: number; updated_at: string; }): void => {
      store.dispatch('sales/deleteContractModel', data)
    }
  },
  {
    name: '.CheckDepositUpdated',
    callback: (data: KwixeoSales.CheckDepositUpdatedEvent): void => {
      emitter.emit('CheckDepositUpdated', data)
    }
  },
  {
    name: '.FecExportUpdated',
    callback: (exportFec: KwixeoSales.FecExport): void => {
      emitter.emit('FecExportUpdated', exportFec)
    }
  },
  {
    name: '.DocumentCreated',
    callback: (datas: KwixeoSales.SaleNextBroadcastDatas): void => {
      const team = JSON.parse(JSON.stringify(store.getters['user/team']))
      const type = datas.type

      if (type === 'invoice' || type === 'credit') {
        team.sales[type + '_date'] = datas.date
      }
      team.sales[type + '_reference'] = datas.next_reference
      store.dispatch('user/setTeam', team)
    }
  },
  {
    name: '.PdfGenerated',
    callback: (datas: KwixeoSales.PdfGenerated): void => {
      emitter.emit('PdfGenerated', datas)
    }
  },
  {
    name: '.AutomotivePdfGenerated',
    callback: (datas: KwixeoSales.AutomotivePdfGenerated): void => {
      emitter.emit('AutomotivePdfGenerated', datas)
    }
  },
  {
    name: '.ClosedPeriodCreated',
    callback: (datas: KwixeoSales.ClosedPeriod): void => {
      const team = JSON.parse(JSON.stringify(store.getters['user/team']))
      team.sales['closed_period'] = datas.end
      store.dispatch('user/setTeam', team)
    }
  },
  {
    name: '.ContractGenerated',
    callback: (datas: KwixeoSales.ContractGenerated): void => {
      emitter.emit('contractGenerated', datas)
    }
  },
  {
    name: '.CustomerSepaGenerated',
    callback: (datas: KwixeoSales.ContractGenerated): void => {
      emitter.emit('sepaGenerated', datas)
    }
  },
  {
    name: '.BrandCreated',
    callback: (data: KwixeoSales.CarBrand): void => {
      if (store.state.automotive.brandsLoaded) {
        const brand = store.state.automotive.brands.find((brand: KwixeoSales.CarBrand) => data.id === brand.id)
        if (!brand || moment(brand.updated_at).isBefore(data.updated_at)) {
          store.dispatch('automotive/loadBrand', brand.id)
        }
      }
    }
  },
  {
    name: '.BrandUpdated',
    callback: (data: KwixeoSales.CarBrand): void => {
      if (store.state.automotive.brandsLoaded) {
        const brand = store.state.automotive.brands.find((brand: KwixeoSales.CarBrand) => data.id === brand.id)
        if (!brand || moment(brand.updated_at).isBefore(data.updated_at)) {
          store.dispatch('automotive/loadBrand', brand.id)
        }
      }
    }
  },
  {
    name: '.BrandDeleted',
    callback: (brand: KwixeoSales.CarBrand): void => {
      store.dispatch('automotive/deleteBrand', brand)
    }
  },
  {
    name: '.BrandModelCreated',
    callback: (datas: KwixeoSales.CarBrandModel): void => {
      if (!store.state.automotive.brandsLoaded) {
        return
      }

      const brand = store.state.automotive.brands.find((brand: KwixeoSales.CarBrand) => datas.brand_id === brand.id)
      if (brand) {
        const model = brand.models.find((model: KwixeoSales.CarBrandModel) => model.id === datas.id)
        if (!model || moment(model.updated_at).isBefore(datas.updated_at)) {
          store.dispatch('automotive/loadBrand', datas.brand_id)
        }
      }
    }
  },
  {
    name: '.BrandModelUpdated',
    callback: (datas: KwixeoSales.CarBrandModel): void => {
      if (!store.state.automotive.brandsLoaded) {
        return
      }

      const brand = store.state.automotive.brands.find((brand: KwixeoSales.CarBrand) => datas.brand_id === brand.id)
      if (brand) {
        const model = brand.models.find((model: KwixeoSales.CarBrandModel) => model.id === datas.id)
        if (!model || moment(model.updated_at).isBefore(datas.updated_at)) {
          store.dispatch('automotive/loadBrand', datas.brand_id)
        }
      }
    }
  },
  {
    name: '.BrandModelDeleted',
    callback: (datas: KwixeoSales.CarBrandModel): void => {
      if (!store.state.automotive.brandsLoaded) {
        return
      }

      const brand = store.state.automotive.brands.find((brand: KwixeoSales.CarBrand) => datas.brand_id === brand.id)
      if (brand) {
        const model = brand.models.find((model: KwixeoSales.CarBrandModel) => model.id === datas.id)
        if (!model || moment(model.updated_at).isBefore(datas.updated_at)) {
          store.dispatch('automotive/loadBrand', datas.brand_id)
        }
      }
    }
  },
  {
    name: '.MultipleBillDone',
    callback: (datas: KwixeoSales.MultipleBillEvent): void => {
      emitter.emit('multipleBillDone', datas)
    }
  },
  {
    name: '.MultipleBillFailed',
    callback: (datas: KwixeoSales.MultipleBillFailedEvent): void => {
      emitter.emit('multipleBillFailed', datas)
    }
  },
  {
    name: '.DocumentSendFailed',
    callback: (datas: KwixeoSales.DocumentSendFailedEvent): void => {
      emitter.emit('documentSendFailed', datas)
    }
  },
  {
    name: '.SignatureDone',
    callback: (signatureDone: KwixeoSales.Signature): void => {
      emitter.emit('signatureDone', signatureDone)
    }
  },
  {
    name: '.AccountTransactionUpdated',
    callback: (transaction: KwixeoSales.AccountTransaction): void => {
      emitter.emit('accountTransactionUpdated', transaction)
    }
  }
])
